module.exports = __webpack_public_path__ + "dec-creditcard-avant-cloud.svg";